module.exports = __webpack_public_path__ + "static/img/listNotNotxt.537c1a0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/listNotNotxt.png
// module id = uaCX
// module chunks = 1